import React, { useEffect, useState } from 'react';
import "./RecordFormDate.scss"
import DateInput from '../../../UI/DateInput/DateInput';
import Dropdown from '../../../UI/Dropdown/Dropdown';

import { useFetching } from '../../../../hooks/useFetching';
import PostService from '../../../../API/PostService';

import { dateFromDDMMYYYYtoYYYYMMDD } from '../../../../helpers/datetime';

import { createTimeSlotsForRecord } from '../../../../helpers/table';

const RecordFormDate = ({
	newRecord,
	dateInputHandler = null,
	timeInputHandler = null,
	selectedRecord = null,
	config,
}) => {
	const [timeSlots, setTimeSlots] = useState([])
	const [record, setRecord] = useState(null)
	const [selectedDate, setSelectedDate] = useState(null)

	useEffect(() => {
		setTimeSlots(createTimeSlotsForRecord())
	}, [])

	useEffect(() => {
		setRecord(selectedRecord)
	}, [selectedRecord])

	const onChangeDate = (value) => {
		// setSelectedDate(value)
		if(dateInputHandler) dateInputHandler(value)

		getDisabledSlots(value, config)
	}

	const selectHandlerTimeStart = (value) => {
		if(timeInputHandler) timeInputHandler(value)
	}

	const getDisabledSlots = (date, config) => {
		if(config.clinic && config.service && date){
			fetchSlots(dateFromDDMMYYYYtoYYYYMMDD(date), config.clinic, config.service)
		}
	}

	const [fetchSlots] = useFetching(async (date, clinicId, serviceId) => {
		const response = await PostService.getTimeSlots(date, clinicId, serviceId)
		if (response.data.success && response.data.result !== false) {
			disableSlots(response.data.result)
		}
	})

	const disableSlots = (slots) => {
		let currentTimeSlots = timeSlots;
		let newArray = [];
		for (let index = 0; index < currentTimeSlots.length; index++) {
			const element = currentTimeSlots[index];
			if(slots[element] && slots[element].disabled === true){

			} else {
				newArray.push(element);
			}
		}

		setTimeSlots(newArray)
	}

	return (
		<div className={"record-form-date" + (newRecord ? " new-record" : "")}>
			<div className="record-form-date__date">
				{
					(newRecord || (!newRecord && record)) &&
					<DateInput inputHandler={onChangeDate} defaultValue={record}/>
				}
			</div>
			<div className="record-form-date__time">
				{newRecord &&
				<>
					<div className="record-form-date__time-selector">
						<Dropdown
							optionsList={timeSlots}
							type='date_part'
							selectedHandler={selectHandlerTimeStart}/>
					</div>
					<div className="record-form-date__time-selector">
						<Dropdown
							optionsList={timeSlots}
							type='date_part'
							selectedHandler={() => {}}/>
					</div>
				</>
				}
				{!newRecord && record &&
					<Dropdown
					optionsList={timeSlots}
					optionSelected={record?.time_formated}
					label='Время'
					type='date_part'
					selectedHandler={selectHandlerTimeStart}/>
				}
			</div>
		</div>
	);
};

export default RecordFormDate;
